// Патч для автоматической защиты от ошибок локализации (React error #31)
// Внедряется автоматически во все компоненты при загрузке приложения

// Безопасная функция для получения локализованного текста
function safeLocalizedText(textObj, language = 'ru', defaultValue = '') {
  try {
    // Если null или undefined, возвращаем дефолтное значение
    if (textObj === null || textObj === undefined) return defaultValue;
    
    // Если примитив, преобразуем в строку
    if (typeof textObj !== 'object') return String(textObj);
    
    // Обрабатываем объект локализации: язык -> en -> ru -> дефолт
    return String(textObj[language] || textObj.en || textObj.ru || defaultValue);
  } catch (e) {
    console.error('[LocalizationPatch] Error:', e);
    return String(defaultValue);
  }
}

// Патчим прототип Object для безопасной локализации
const originalToString = Object.prototype.toString;

Object.prototype.toString = function() {
  // Проверяем, является ли объект объектом локализации с ru/en ключами
  if (
    this && 
    typeof this === 'object' && 
    (this.ru !== undefined || this.en !== undefined) &&
    Object.keys(this).length <= 3
  ) {
    const language = localStorage.getItem('portfolioLanguage') || 'ru';
    return safeLocalizedText(this, language, '[Локализация]');
  }
  
  // Для всех других объектов используем оригинальное поведение
  return originalToString.call(this);
};

// Патчим React.createElement для автоматической обработки объектов локализации
const React = window.React;
if (React && React.createElement) {
  const originalCreateElement = React.createElement;
  
  React.createElement = function(type, props, ...children) {
    // Обрабатываем атрибуты компонентов, которые могут содержать локализацию
    if (props) {
      const localizableProps = ['title', 'alt', 'placeholder', 'label', 'aria-label'];
      const language = localStorage.getItem('portfolioLanguage') || 'ru';
      
      localizableProps.forEach(prop => {
        if (props[prop] && typeof props[prop] === 'object') {
          props[prop] = safeLocalizedText(props[prop], language);
        }
      });
    }
    
    // Обрабатываем дочерние компоненты рекурсивно
    const processedChildren = children.map(child => {
      if (child && typeof child === 'object' && !React.isValidElement(child)) {
        const language = localStorage.getItem('portfolioLanguage') || 'ru';
        return safeLocalizedText(child, language);
      }
      return child;
    });
    
    return originalCreateElement.call(this, type, props, ...processedChildren);
  };
}

console.log('[LocalizationPatch] Installed successfully');

export default { safeLocalizedText };
